module.exports = __webpack_public_path__ + "static/media/endorsement-tick.b47e85d5.svg";